<nav
  class="w-full border-b flex items-center sticky z-50 shadow-sm top-0 header-bg"
>
  <div class="p-4 flex-wrap flex items-center justify-between gap-4 w-full">
    <div class="flex items-center gap-4">
      <p-button
        (click)="toggleSidebar()"
        severity="secondary"
        [icon]="icons.bars"
        aria-label="menu"
      />
      <div>
        <p-breadcrumb
          class="max-w-full text-sm"
          [model]="items"
          [home]="canViewHome ? home : undefined"
        >
          <!-- Breadcrumb items -->
          <ng-template #item let-item>
            @if (item.routerLink) {

            <a
              [routerLink]="formatRouterLink(item.routerLink)"
              class="p-breadcrumb-item-link"
            >
              <span
                [ngClass]="[item.icon ? item.icon : '', 'text-color']"
              ></span>
              <span class="font-medium">{{ item.label | transloco }}</span>
            </a>

            }
          </ng-template>

          <!-- Home icon / item -->
          <ng-template pTemplate="home" let-item>
            <a [routerLink]="item.routerLink" class="p-breadcrumb-home-link">
              <i [class]="icons.home"></i>
            </a>
          </ng-template>
        </p-breadcrumb>
      </div>
    </div>
    <div class="flex items-center gap-6 lg:gap-2">
      <app-user-avatar></app-user-avatar>
      <app-notifications class="mx-4"></app-notifications>
      <rieaya-language-picker [lang]="LANG"></rieaya-language-picker>
    </div>
  </div>
</nav>
@if (isMenuOpen) {
<div
  (click)="toggleSidebar()"
  class="fixed z-50 top-0 w-[100vw] h-[100svh] bg-black/30"
></div>
}
